module.exports = __webpack_public_path__ + "img/naga_guardian_small.6adc1003.png";